<template>
    <v-col v-if="customer">
        <div class="wrap-head-detail">
            <v-btn class="btn-back" elevation="0" text @click="$router.go(-1)">
                <v-icon size="18">mdi-arrow-left</v-icon>
                {{ $t("global.back") }}
            </v-btn>

            <div class="wrap-head-btn d-flex align-center">
                <h1>{{ customer.name }}</h1>
                <span class="id-client">#{{
                        String(customer.id).padStart(4, '0')
                    }}</span>
            </div>
        </div>
        <div class="wrap-detail">
            <div class="wrap-detail-element">
                <v-row>
                    <v-col cols="12">
                        <h2>{{ $t("customers.informations") }}</h2>
                        <hr class="trait secondary"/>
                    </v-col>
                </v-row>
                <div class="wrap-detail-content">
                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="element">
                                <span class="libelle">
                                    {{ $tc("customers.address", 1) }}
                                </span>
                                <span class="content">
                                    {{ customer.address_1 | preventNull }}<br/>
                                    {{ customer.address_2 | preventNull }}<br/>
                                    {{ customer.zipcode | preventNull }} {{ customer.city }}
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="element">
                                <span class="libelle">
                                    {{ $t("customers.phone") }}
                                </span>
                                <span class="content">{{
                                        customer.phone | preventNull
                                    }}</span>
                            </div>
                        </v-col>
                        <v-col cols="12" md="3">
                            <div class="element">
                                <span class="libelle">
                                    {{ getBooleanLabel() }}
                                </span>
                                <span class="content">{{ $t(`global.${customer.collect_trays}`) }}</span>
                            </div>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="element">
                                <span class="libelle">
                                    {{ $t("customers.active") }}
                                </span>
                                <span class="content">{{
                                        $t(`global.${customer.is_active}`)
                                    }}</span>
                            </div>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="element">
                                <span class="libelle">
                                    {{ idLabel }}
                                </span>
                                <span class="content">
                                    {{ customer.code | preventNull }}
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </div>

            <!--div class="wrap-detail-element">
                <v-row>
                    <v-col cols="12">
                        <h2>{{ $t("customers.code_tag") }}</h2>
                        <hr class="trait secondary"/>
                    </v-col>
                </v-row>
                <div class="wrap-detail-content">
                    <form ref="form_code_tag">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="customer.fridge_code"
                                    :label="$t('customers.code')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-btn id="btn-valifd-form_code_tag"
                                       class="btn-valid-form"
                                       color="primary"
                                       :loading="savingFridgeCode"
                                       @click="onSaveFridgeCodeClick">
                                    {{ $t("global.save") }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </form>
                </div>
            </div-->
            <div class="wrap-detail-element">
                <v-row>
                    <v-col cols="12">
                        <h2>{{ $t("customers.note_tag") }}</h2>
                        <hr class="trait secondary"/>
                    </v-col>
                </v-row>
                <div class="wrap-detail-content">
                    <form ref="form_note_tag">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="customer.note"
                                    :label="$t('customers.note')"
                                    :rules="note_rules"
                                    counter="50"
                                    max
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-btn id="btn-valifd-form_note_tag"
                                       class="btn-valid-form"
                                       color="primary"
                                       :loading="savingNote"
                                       @click="onSaveNoteClick">
                                    {{ $t("global.save") }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </form>
                </div>
            </div>
            <div class="wrap-detail-element">
                <v-row>
                    <v-col cols="12">
                        <h2>{{ $t("customers.payment_mode") }}</h2>
                        <hr class="trait secondary"/>
                    </v-col>
                </v-row>
                <div class="wrap-detail-content">
                    <form ref="form_code_tag">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="customer.payment_mode"
                                    :items="paymentModes"
                                    :label="$t('customers.payment_mode')"
                                    :item-text="item => item.label"
                                    :item-value="item => item.id"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-btn id="btn-valifd-form_code_tag"
                                       class="btn-valid-form"
                                       color="primary"
                                       :loading="savingPaymentMode"
                                       @click="onSavePaymentModeClick">
                                    {{ $t("global.save") }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </form>
                </div>
            </div>
            <div class="wrap-detail-element">
                <v-row>
                    <v-col cols="12">
                        <h2>{{ $t("customers.models_tours_associate") }}</h2>
                        <hr class="trait secondary"/>
                    </v-col>
                </v-row>
                <div class="wrap-detail-content">
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="models"
                                :items-per-page="-1"
                                hide-default-footer
                            >
                                <template #[`item.designation`]="{item}">
                                    {{ item.model_number.site.code }}{{ item.model_number.code }}
                                </template>
                                <template #[`item.types_tours`]="{item}">
                                    {{ item.tour_type.designation }}
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
    </v-col>
    <v-col v-else>
        {{ $t('global.loading') }}
    </v-col>
</template>

<script>
import Config from '../../../config.singleton'

export default {
    name: "DetailsCustomers",

    data() {
        return {
            code: "",
            note: "",
            headers: [
                {
                    text: this.$t("customers.designation_models_tours"),
                    align: "start",
                    sortable: true,
                    value: "designation",
                },
                {
                    text: this.$t("customers.type_tours"),
                    align: "start",
                    sortable: true,
                    value: "types_tours",
                },
            ],
            items: [
                {
                    designation: "M1",
                    types_tours: "Classique",
                },
                {
                    designation: "M1",
                    types_tours: "Mercredi",
                },
                {
                    designation: "M5",
                    types_tours: "Classique",
                },
            ],
            customer: null,
            savingFridgeCode: false,
            savingNote: false,
            note_rules: [v => v.length <= 50 || 'Maximum 50 caractères'],
            paymentModes: [],
            savingPaymentMode: false,
        };
    },

    computed: {
        models() {
            if (!this.customer.tour_models)
                return []

            return this.customer.tour_models
        },
        idLabel() {
            return Config.id_label ?? this.$t("customers.code")
        },
    },

    mounted() {
        const customerId = this.$route.params.id

        this.getCustomer(customerId)

        this.getPaymentModes()
    },

    methods: {
        async getCustomer(id) {
            this.customer = (await this.$api.customers.get(id, {
                params: {
                    includes: 'customer.tour_models,tour_model.model_number,model_number.site,tour_model.tour_type'
                }
            })).data.data
        },
        async getPaymentModes() {
            this.paymentModes = (await this.$api.payment_modes.all()).data.data
        },
        async onSavePaymentModeClick() {
            try {
                this.savingPaymentMode = true
                await this.$api.customers.update(this.customer.id, {
                    payment_choise_id: this.customer.payment_mode
                })
                this.savingPaymentMode = false
            } catch (e) {
                this.savingPaymentMode = false
            }
        },
        async onSaveFridgeCodeClick() {
            try {
                this.savingFridgeCode = true
                await this.$api.customers.update(this.customer.id, {
                    fridge_code: this.customer.fridge_code
                })
                this.savingFridgeCode = false
            } catch (e) {
                this.savingFridgeCode = false
            }

        },
        async onSaveNoteClick() {
            try {
                this.savingNote = true
                await this.$api.customers.update(this.customer.id, {
                    fridge_code: this.customer.fridge_code,
                    note: this.customer.note
                })
                this.savingNote = false
            } catch (e) {
                this.savingNote = false
            }

        },
        getBooleanLabel() {
            return Config.boolean_label ?? this.$t("customers.recovery_container")
        },
    }
};
</script>
